import { createContext, useContext, useEffect, useState } from "react";
import { getSiteImages, siteImageUrl } from "@/lib/api";

const DEFAULTS = { logo_wordmark: "/logo-wordmark.webp", logo_mark: "/logo-mark.webp", hero_visual: null, about_image: null };
const Ctx = createContext({ src: (slot) => DEFAULTS[slot], refresh: () => {} });

export const SiteImagesProvider = ({ children }) => {
  const [images, setImages] = useState({});

  const refresh = () => getSiteImages().then(setImages).catch(() => {});
  useEffect(() => { refresh(); }, []);

  const src = (slot) => {
    const info = images[slot];
    if (info?.custom) return siteImageUrl(slot, info.version);
    return DEFAULTS[slot] ?? null;
  };

  useEffect(() => {
    const href = src("logo_mark");
    document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]').forEach((l) => {
      if (images.logo_mark?.custom) l.setAttribute("href", href);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images]);

  return <Ctx.Provider value={{ src, refresh, images }}>{children}</Ctx.Provider>;
};

export const useSiteImages = () => useContext(Ctx);
